import { useEffect, useRef } from 'react';
import { usePersistFn } from './usePersistFn';

export function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const defaultEquals = (x: any, y: any) => x === y;

export const useWatchValue = <T>(
  value: T,
  onChange: (prev: T | undefined, curr: T) => void,
  equals?: (x: T, y: T) => boolean,
) => {
  const ref = useRef<T>();
  const handler = usePersistFn(onChange);
  const equalsRef = usePersistFn(equals ?? defaultEquals);
  useEffect(() => {
    if (
      (ref.current != null && value == null) ||
      (ref.current == null && value != null) ||
      (ref.current != null && value != null && !equalsRef(ref.current, value))
    ) {
      handler(ref.current, value);
      ref.current = value;
    }
  }, [equalsRef, handler, value]);
};
